// @ts-expect-error
import {createAction} from 'redux-act';

import type {WhatsAppReportDataRequestedAction} from '../types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: WhatsAppReportDataRequestedAction['payload']
) => WhatsAppReportDataRequestedAction = createAction('WHATSAPP_REPORT_DATA_REQUESTED');
export const updateReportChartData = createAction('WHATSAPP_REPORT_CHART_DATA_UPDATED');
export const updateReportMaps = createAction('WHATSAPP_REPORT_MAPS_UPDATED');
export const failReportChartData = createAction('WHATSAPP_REPORT_CHART_DATA_FAILED');
